'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

window.console || (window.console = {
	log: function log() {}
});
var BOURBON = window.BOURBON || null;
var cssua = window.cssua || null;

(function ($) {
	var _BOURBON;

	var siteName = 'bourbon';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	BOURBON = (_BOURBON = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (BOURBON.va.window.width < BOURBON.va.device.sp) {
						pos -= 60;
					} else {
						pos -= 110;
					}
				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		easeScrollHash: function easeScrollHash() {
			var hash = location.hash;
			if (hash !== '') {
				$(window).on('load', function () {
					$('html, body').css('display', 'none');

					setTimeout(function () {
						$('html, body').css('display', 'block');

						var _hash = '#' + hash.split('#')[1];
						var pos = $(_hash).offset().top;

						if (BOURBON.va.window.width < BOURBON.va.device.sp) {
							pos -= 60;
						} else {
							if ($('.container').hasClass('company')) {
								pos -= 155;
							} else {
								pos -= 110;
							}
						}
						$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 100);
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		headerScroll: function headerScroll() {
			var $header = $('.header');
			var timer = void 0,
			    flag = void 0;

			$(window).scroll(function (e) {
				var thisScroll = $(e.currentTarget).scrollTop();

				if (timer) clearTimeout(timer);
				if (thisScroll === 0 && flag) {
					$header.removeClass('is-move');
					flag = false;
				} else if (thisScroll > 0 && !flag) {
					$header.addClass('is-move');
					flag = true;
				}
			});
		},
		headerSwitch: function headerSwitch() {
			var $hamburger = $('.header-hamburger');
			var $nav = $('.header-nav');
			var $overlay = $('.header-overlay');
			var $siteSearch = $('.header-siteSearch');
			var flag = false;
			var scrollTopNow = void 0;

			if (BOURBON.va.window.width < 1024) {
				// ハンバーガーメニュー
				$hamburger.on('click', function () {
					if (!flag) {
						$overlay.addClass(a);
						$siteSearch.removeClass(v);
						setTimeout(function () {
							$siteSearch.removeClass(a);
							$overlay.addClass(v);
						});
						$nav.addClass(a);
						$hamburger.addClass(a);
						fixedOnContainer();
						flag = true;
					} else {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
						}, 400);
						$nav.removeClass(a);
						$hamburger.removeClass(a);
						fixedOffContainer();
						flag = false;
					}
				});
			} else {
				// pcホバーメニュー
				var productBtn = $('.js-header-product');
				var productContent = $('.js-header-product-content');
				var companyBtn = $('.js-header-company');
				var companyContent = $('.js-header-company-content');
				var aboutBtn = $('.js-header-about');
				var aboutContent = $('.js-header-about-content');
				var qualityBtn = $('.js-header-quality');
				var qualityContent = $('.js-header-quality-content');
				var csrBtn = $('.js-header-csr');
				var csrContent = $('.js-header-csr-content');
				var pcMousehover = function pcMousehover(_btn, _content) {
					_btn.on('mouseenter', function () {
						$('.header-pcMenu').removeClass(a);
						_content.addClass(a);
						setTimeout(function () {
							$('.header-pcMenu').removeClass(v);
							_content.addClass(v);
						});
					});
					_content.on('mouseleave', function () {
						if (_content.hasClass(a)) {
							$('.header-pcMenu').removeClass(v);
							setTimeout(function () {
								$('.header-pcMenu').removeClass(a);
							});
						}
					});
				};
				pcMousehover(productBtn, productContent);
				pcMousehover(companyBtn, companyContent);
				pcMousehover(aboutBtn, aboutContent);
				pcMousehover(qualityBtn, qualityContent);
				pcMousehover(csrBtn, csrContent);

				var notList = '.js-header-product, .js-header-company, .js-header-about, .js-header-quality, .js-header-csr';
				$('.header-nav-head').not(notList).on('mouseenter', function () {
					$('.header-pcMenu').removeClass(v);
					setTimeout(function () {
						$('.header-pcMenu').removeClass(a);
					});
				});
			}

			// サイト内検索
			$('.js-header-siteSearch').on('click', function () {
				fixedOnContainer();
				$overlay.addClass(a);
				$siteSearch.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$siteSearch.addClass(v);
				});
				$nav.removeClass(a);
				$hamburger.removeClass(a);
				flag = false;
			});
			$overlay.on('click', function () {
				$siteSearch.removeClass(v);
				$overlay.removeClass(v);
				setTimeout(function () {
					$siteSearch.removeClass(a);
					$overlay.removeClass(a);
				}, 400);
				fixedOffContainer();
				$nav.removeClass(a);
				$hamburger.removeClass(a);
				flag = false;
			});

			// マーズフラッグ検索結果
			if (location.pathname === '/search.html' || location.pathname === '/english/search.html' || location.pathname === '/chinese/search.html') {
				$('.mf_finder_searchBox_submit').on('click', function () {
					$siteSearch.removeClass(v);
					$overlay.removeClass(v);
					setTimeout(function () {
						$siteSearch.removeClass(a);
						$overlay.removeClass(a);
					}, 400);
					fixedOffContainer();
					$nav.removeClass(a);
					$hamburger.removeClass(a);
					flag = false;
				});
			}

			var fixedOnContainer = function fixedOnContainer() {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			var fixedOffContainer = function fixedOffContainer() {
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};
		}
	}, _defineProperty(_BOURBON, 'pageTop', function pageTop() {
		var $pagetop = $('.footer-pagetop');

		$(window).scroll(function (e) {
			var $this = $(e.currentTarget);
			var $footer = $('.footer');
			var footerPos = $footer.offset().top + $footer.height();
			var thisScroll = $this.scrollTop();
			var pagetopPos = $this.height() + $footer.height() + thisScroll;

			if (thisScroll > '150') {
				$pagetop.addClass(v);
			} else {
				$pagetop.removeClass(v);
			}
			if (footerPos <= pagetopPos) {
				$pagetop.addClass('is-bottom');
			} else {
				$pagetop.removeClass('is-bottom');
			}
		});
	}), _defineProperty(_BOURBON, 'sns', function sns() {
		if ($('.js-share-line').length) {
			$('.js-share-line').attr('href', 'https://social-plugins.line.me/lineit/share?url=' + location.href);
		}
		if ($('.js-share-twitter').length) {
			$('.js-share-twitter').attr('href', 'https://twitter.com/share?url=' + location.href);
		}
		if ($('.js-share-facebook').length) {
			$('.js-share-facebook').attr('href', 'http://www.facebook.com/share.php?u=' + location.href);
		}
	}), _defineProperty(_BOURBON, 'sideNavCurrent', function sideNavCurrent() {
		$('.mod-sideNav-nav-ul-li-a:not(.mod-sideNav-nav-head)').each(function (idx, ele) {
			if (BOURBON.va.pathname === $(ele).attr('href') || BOURBON.va.pathname === $(ele).attr('href') + 'index.html') {
				$(ele).addClass(a);
			}
		});
	}), _defineProperty(_BOURBON, 'tabChange', function tabChange() {
		if ($('.mod-tab').length) {
			if ($('.mod-tab').eq(0).hasClass('js-tabChange')) {
				var $hash = location.hash;
				if ($hash.length) {
					$('.mod-tab-btn').each(function (idx, ele) {
						if ($(ele).attr('data-name') === $hash.replace('#', '')) {
							$(ele).addClass(a);
							$('.mod-tab-content').eq(idx).addClass(a);
						}
					});
				} else {
					$('.mod-tab-content').eq(0).addClass(a);
					$('.mod-tab-btn').eq(0).addClass(a);
				}
				$('.mod-tab-btn').each(function (idx, val) {
					$(val).on('click', function () {
						$('.mod-tab-btn').removeClass(a);
						$(val).addClass(a);
						$('.mod-tab-content').removeClass(a);
						$('.mod-tab-content').eq(idx).addClass(a);
					});
				});
			}
		}
	}), _defineProperty(_BOURBON, 'marsflag', function marsflag() {
		var el = document.createElement('script');
		if (location.pathname !== '/search.html' && location.pathname !== '/english/search.html' && location.pathname !== '/chinese/search.html') {
			// マーズフラッグ検索窓用js
			el.src = "//ce.mf.marsflag.com/latest/js/mf-search.js";
		}
		setTimeout(function () {
			document.body.appendChild(el);
		}, 100);
	}), _defineProperty(_BOURBON, 'loadDelayScript', function loadDelayScript() {
		var _this = this;
		_this.nextToggle();
		_this.easeScroll();
		_this.easeScrollHash();
		_this.pageTop();
		_this.headerScroll();
		_this.headerSwitch();
		_this.pageTop();
		_this.sns();
		_this.sideNavCurrent();
		_this.tabChange();
		_this.marsflag();
		svg4everybody();
	}), _BOURBON);

	$(function () {
		return BOURBON.localDecision() ? BOURBON.localLoading() : BOURBON.loadDelayScript();
	});
})(window.jQuery);